import { render } from "./Periods.vue?vue&type=template&id=3a4b1852"
import script from "./Periods.vue?vue&type=script&lang=js"
export * from "./Periods.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__